import { identifyPassTypeFromCode } from "../../../app/offers/OfferPassLeftSection";
import { BaseAction } from "../../../core/actions/BaseAction";
import { calculatePrice } from "../../../Lib/Utils/validationUtil";
import { enumOfferPassType, enumPassType, TripTypeEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { dropSupersededAdmissions, getOffersForDirection } from "../../../Lib/Utils/exchangeTrips";
import { IBookingPassenger, ISelectedPassenger } from "../../../Orchestrator/Types/Index";
import { IGetPassengerListByOfferAdmissionsActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/FilterTripAction";


class GetPassengerListByOfferAdmissionsAction extends BaseAction<IBookingPassenger, IGetPassengerListByOfferAdmissionsActionParams> {

    override async run(): Promise<IBookingPassenger> {
        const passengerList: IBookingPassenger = {
            outbound: [],
            inbound: []
        }
        const processedPrivacySeatingAdmissions = new Set<string>();
        try {
            const { passengers, allTrip, bookedOffers } = this.params!;

            // Mid-exchange a direction holds both the original trip (admissions
            // EXCHANGE_ONGOING) and its replacement (PREBOOKED); see
            // `getOffersForDirection` for why reading only the first trip billed
            // AED 0. Outside an exchange both helpers are no-ops.
            const outBoundOffers = getOffersForDirection(allTrip, bookedOffers, TripTypeEnum.OUT_BOUND)
            const inBoundOffers = getOffersForDirection(allTrip, bookedOffers, TripTypeEnum.IN_BOUND)

            {
                if (outBoundOffers && outBoundOffers.length > 0) {
                    const allTheOutBoundPassengerId = Array.from(new Set(outBoundOffers?.flatMap(off => (off?.admissions || [])?.flatMap(add => add.passengerIds || []))))
                    passengerList.outbound = JSON.parse(JSON.stringify([...passengers]))
                        .filter((d: ISelectedPassenger) => allTheOutBoundPassengerId?.includes(d.id))
                        .map((pass: ISelectedPassenger) => {
                            if (allTheOutBoundPassengerId?.includes(pass.id)) {
                                const admissionsForPassenger = dropSupersededAdmissions(
                                    outBoundOffers?.flatMap(off => (off?.admissions || [])?.filter(add => add.passengerIds?.includes(pass.id)))
                                )
                                if (admissionsForPassenger.length > 0) {
                                    // TODO: Validate here for monthly pass as well
                                    const isPassApplied = admissionsForPassenger.some(add => add.appliedReductions?.some(reduction => reduction.type === "TRAVEL_PASS"))
                                    const allPassCodes: string[] = admissionsForPassenger?.map(i => i?.appliedReductions)?.flat()?.map(i => i?.code)?.filter(code => code !== undefined)

                                    const totalPrice = admissionsForPassenger?.reduce((sum: number, add) => {
                                        if (add.offerMode === "COLLECTIVE" && add.passengerIds && add.passengerIds.length > 1) {
                                            if (processedPrivacySeatingAdmissions.has(add.id)) {
                                                return sum + 0;
                                            } else {
                                                processedPrivacySeatingAdmissions.add(add.id);
                                                return sum + calculatePrice(add.price);
                                            }
                                        } else {
                                            return sum + calculatePrice(add.price);
                                        }
                                    }, 0)
                                    const totalOriginalPrice = admissionsForPassenger?.reduce((sum: number, add) => {
                                        if (add.offerMode === "COLLECTIVE" && add.passengerIds && add.passengerIds.length > 1) {
                                            if (processedPrivacySeatingAdmissions.has(add.id)) {
                                                return sum + 0;
                                            } else {
                                                return sum + calculatePrice(add.originalPrice);
                                            }
                                        } else {
                                            return sum + calculatePrice(add.originalPrice);
                                        }
                                    }, 0)

                                    pass.passengerPrice = isPassApplied ? totalOriginalPrice : totalPrice
                                    pass.passAmount = isPassApplied ? totalOriginalPrice - totalPrice : 0
                                    if (allPassCodes.length) {
                                        pass.passType = identifyPassTypeFromCode(allPassCodes[0])
                                    }
                                    pass.passengerStatus = admissionsForPassenger[0].status
                                }
                            }
                            return pass
                        })
                }
            }

            {
                if (inBoundOffers && inBoundOffers.length > 0) {
                    const allTheInBoundPassengerId = Array.from(new Set(inBoundOffers?.flatMap(off => (off?.admissions || [])?.flatMap(add => add.passengerIds || []))))
                    passengerList.inbound = JSON.parse(JSON.stringify([...passengers]))
                        .filter((d: ISelectedPassenger) => allTheInBoundPassengerId?.includes(d.id))
                        .map((pass: ISelectedPassenger) => {
                            if (allTheInBoundPassengerId?.includes(pass.id)) {
                                const admissionsForPassenger = dropSupersededAdmissions(
                                    inBoundOffers?.flatMap(off => (off?.admissions || [])?.filter(add => add.passengerIds?.includes(pass.id)))
                                )
                                if (admissionsForPassenger.length > 0) {
                                    // TODO: Validate here for monthly pass as well
                                    const isPassApplied = admissionsForPassenger.some(add => add.appliedReductions?.some(reduction => reduction.type === "TRAVEL_PASS"))
                                    const allPassCodes: string[] = admissionsForPassenger?.map(i => i?.appliedReductions)?.flat()?.map(i => i?.code)?.filter(code => code !== undefined)

                                    const totalPrice = admissionsForPassenger?.reduce((sum: number, add) => {
                                        if (add.offerMode === "COLLECTIVE" && add.passengerIds && add.passengerIds.length > 1) {
                                            if (processedPrivacySeatingAdmissions.has(add.id)) {
                                                return sum + 0;
                                            } else {
                                                processedPrivacySeatingAdmissions.add(add.id);
                                                return sum + calculatePrice(add.price);
                                            }
                                        } else {
                                            return sum + calculatePrice(add.price);
                                        }
                                    }, 0)
                                    const totalOriginalPrice = admissionsForPassenger?.reduce((sum: number, add) => {
                                        if (add.offerMode === "COLLECTIVE" && add.passengerIds && add.passengerIds.length > 1) {
                                            if (processedPrivacySeatingAdmissions.has(add.id)) {
                                                return sum + 0;
                                            } else {
                                                return sum + calculatePrice(add.originalPrice);
                                            }
                                        } else {
                                            return sum + calculatePrice(add.originalPrice);
                                        }
                                    }, 0)

                                    pass.passengerPrice = isPassApplied ? totalOriginalPrice : totalPrice
                                    pass.passAmount = isPassApplied ? totalOriginalPrice - totalPrice : 0
                                    if (allPassCodes.length) {
                                        pass.passType = identifyPassTypeFromCode(allPassCodes[0])
                                    }
                                    pass.passengerStatus = admissionsForPassenger[0].status
                                }
                            }
                            return pass
                        })
                }
            }

        } catch (error: any) {
            console.error("Error fetching Data:", error);
        } finally {
            return passengerList
        }
    }
}

export const getPassengerListByOfferAdmissionsAction = new GetPassengerListByOfferAdmissionsAction()